module.exports = __webpack_public_path__ + "img/Innovazioni Griglia 4.5b58ad17.webp";